import { apiClient } from './client';

export interface PushStats {
  subscriptions: number;
}

export interface PushSendResult {
  sent: number;
  failed: number;
}

export interface PushSendBody {
  title?: string;
  body: string;
  url?: string;
  target: 'all' | 'client';
  clientId?: string;
}

export const pushApi = {
  stats: async (): Promise<PushStats> => {
    const { data } = await apiClient.get('/admin/push/stats');
    return data as PushStats;
  },
  send: async (body: PushSendBody): Promise<PushSendResult> => {
    const { data } = await apiClient.post('/admin/push/send', body);
    return data as PushSendResult;
  },
};
